import { Typography, Container } from '@mui/material';
import BalanceIcon from '@mui/icons-material/Balance';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import OilBarrelIcon from '@mui/icons-material/OilBarrel';
import SettingsIcon from '@mui/icons-material/Settings';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function AboutDigitization() {
  const [images, setImages] = useState(1);
  const [curves, setCurves] = useState(1);
  const [feet, setFeet] = useState(1);
  const [quote, setQuote] = useState('');
  const [quoteValue, setQuoteValue] = useState(0);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          const navbarHeight = 80; // Approximate navbar height
          const elementPosition = element.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: elementPosition - navbarHeight,
            behavior: 'smooth'
          });
        }, 100);
      }
    } else {
      // If no hash, scroll to top immediately
      window.scrollTo(0, 0);
    }
  }, [location]);

  const handleSubmit = () => {
    const raw = (images * 20) + (images * curves * feet) * 0.0015;
    const roundedUp = Math.ceil(raw * 100) / 100;
    const formattedNumber = roundedUp.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    setQuote(`$${formattedNumber}`);
    setQuoteValue(roundedUp);
  };
  const handleReset = () => {
    setImages(1);
    setCurves(1);
    setFeet(1);
    setQuote('');
    setQuoteValue(0);
  };    

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#000000ff',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}>
      <Container maxWidth={false} sx={{ py: 4, width: '100%' }}>
        <div style={{minWidth: '1230px', overflow: 'hidden', borderRadius: '16px', display: 'flex', justifyContent: 'center',
             boxShadow: '0 4px 16px rgba(0,0,0,0.5)', alignItems: 'center', paddingTop: '75px' }}>
              <img src="/DCTAX-VECTORIZED.svg" alt="Section"
                style={{ display: 'block', width: '700px', height: '200px', objectFit: 'cover', objectPosition: 'center' }}/>
        </div>     
        <div 
          style={{ width: '100%', background: '#000', boxSizing: 'border-box', padding: '0 max(24px, calc((100vw - 1300px) / 2)) 50px' }}>  
        </div>
        <div style={{ position: 'relative', width: '100%', background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'flex-start',
          minHeight: '400px', boxSizing: 'border-box', gap: '50px', padding: '0px max(24px, calc((100vw - 1300px) / 2)) 0', flexDirection: 'column', 
          minWidth: '1230px', }}>
          <div style={{width: '100%', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', 
            flexWrap: 'nowrap', minHeight: '400px', boxSizing: 'border-box', gap: '20px', }}>
              <div style={{flex: '1 1 600px', color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '2rem', fontWeight: 500, 
                maxWidth: '700px', minWidth: '575px', }}>
                <p style={{ marginTop: '2.1px', fontSize: '2rem', textAlign: 'left', lineHeight: 1.5 }}>
                  Mineral Property Taxes, <b>Simplified.</b>
                </p>
                <p style={{marginTop: '24px', fontSize: '1.25rem', fontFamily: 'Inter, sans-serif', lineHeight: 1.5, textAlign: 'left' }}>
                  The DCATax app puts the power of Mineral Ad Valorem tax calculation in your hands with a one-stop solution for
                    tax calculations and data.  There's no longer a need to be an industry professional to understand where your values
                  are coming from.  Stop wasting time and money on expensive consultants or complex state agency processes.
                </p>
                <div style={{ marginTop: '24px', display: 'flex', justifyContent: 'center', width: '100%' }}>
                  <button style={{ background: 'linear-gradient(to top left, #a4fdffff 0%, #a4fdffff 55%, #ffffff 100%)', color: '#000', border: 'none', borderRadius: '8px',
                    padding: '12px 24px', fontSize: '1rem', fontWeight: 700, cursor: 'pointer', boxShadow: '0 4px 12px rgba(0,0,0,0.25)' }}
                    onMouseDown={e => e.currentTarget.style.background = '#8d8c8cff'}
                    onMouseUp={e => e.currentTarget.style.background = 'linear-gradient(to top left, #a4fdffff 0%, #a4fdffff 55%, #ffffff 100%)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'linear-gradient(to top left, #a4fdffff 0%, #a4fdffff 55%, #ffffff 100%)'}
                    onClick={() => window.location.href = 'mailto:test_email@domain.com'}>
                    Reach Out for a Quote
                  </button>
                </div>
              </div>
              <div style={{ minWidth: '650px', position: 'relative', borderRadius: '16px' }}>
                <div aria-hidden="true" style={{ position: 'absolute', inset: "-15px", borderRadius: '16px', opacity: 0.9,
                  background: 'linear-gradient(to top left, #a4fdffff 0%, #000 100%)', transform: 'translate(-3px, -5px)', filter: 'blur(10px)',  }} />
                <img src="/shaking_hands.jpg" alt="Section"
                style={{ position: 'relative', zIndex: 1, display: 'block', height: '100%', width: '100%', objectFit: 'cover', borderRadius: '16px' }} />
              </div>
          </div>
          <div style={{ width: '100%', maxWidth: '1600px', margin: '50px auto 25px', display: 'flex', justifyContent: 'center' }}>
            <div style={{ height: '1px', background: '#a4fdffff', opacity: 0.9, width: '90%' }} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', width: '1230px', boxSizing: 'border-box', alignItems: 'center', }}>
            <Typography variant="h1" header style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '2.25rem', 
              fontWeight: 500, textAlign: 'left' }}>
              Tax Expertise Isn't Oilfield Expertise 
            </Typography>
          </div>
          <div style={{ margin: '20px auto 20px', width: '1230px', display: 'flex', alignItems: 'stretch', justifyContent: 'center', gap: '24px' }}>
            <div style={{ flex: '1 1 0', border: '2px solid #a4fdffff', borderRadius: '16px', padding: '28px', boxSizing: 'border-box' }}>
              <Typography variant="h2" style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.6rem', fontWeight: 700, textAlign: 'center' }}>
                Property Tax Expertise
              </Typography>
              <div style={{ height: '2px', width: '100%', background: '#a4fdffff', margin: '18px 0 24px' }} />
              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                {[[BalanceIcon, 'Tax Code'], [AssignmentTurnedInIcon, 'Appraisal'], [FolderOpenIcon, 'Procedures']].map(([Icon, label]) => (
                  <div key={label} style={{ display: 'flex', alignItems: 'center', gap: '18px' }}>
                    <div style={{ width: '48px', height: '48px', flex: '0 0 48px', borderRadius: '50%', background: '#0b4da2', border: '2px solid #a4fdffff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Icon sx={{ color: '#fff', fontSize: 28 }} />
                    </div>
                    <Typography style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.2rem', fontWeight: 500 }}>{label}</Typography>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ flex: '0 0 270px', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
              <div style={{ position: 'absolute', left: '-24px', right: '-24px', top: '50%', height: '2px', background: '#a4fdffff', transform: 'translateY(-50%)' }} />
              <div style={{ position: 'absolute', left: '-8px', top: '50%', width: 0, height: 0, borderTop: '8px solid transparent', borderBottom: '8px solid transparent', borderLeft: '12px solid #a4fdffff', transform: 'translateY(-50%)', zIndex: 2 }} />
              <div style={{ position: 'absolute', right: '-8px', top: '50%', width: 0, height: 0, borderTop: '8px solid transparent', borderBottom: '8px solid transparent', borderRight: '12px solid #a4fdffff', transform: 'translateY(-50%)', zIndex: 2 }} />
              <div style={{ position: 'relative', width: '100%', minHeight: '150px', border: '2px solid #a4fdffff', borderRadius: '16px', background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', boxSizing: 'border-box', zIndex: 1 }}>
                <Typography variant="h2" style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.55rem', lineHeight: 1.3, fontWeight: 700, textAlign: 'center' }}>
                  Mineral Property Tax Expertise
                </Typography>
              </div>
            </div>
            <div style={{ flex: '1 1 0', border: '2px solid #a4fdffff', borderRadius: '16px', padding: '28px', boxSizing: 'border-box' }}>
              <Typography variant="h2" style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.6rem', fontWeight: 700, textAlign: 'center' }}>
                Oilfield Expertise
              </Typography>
              <div style={{ height: '2px', width: '100%', background: '#a4fdffff', margin: '18px 0 24px' }} />
              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                {[[OilBarrelIcon, 'Reservoir Analysis'], [SettingsIcon, 'Oilfield Operations'], [WaterDropIcon, 'Lease Operating Expense Analysis']].map(([Icon, label]) => (
                  <div key={label} style={{ display: 'flex', alignItems: 'center', gap: '18px' }}>
                    <div style={{ width: '48px', height: '48px', flex: '0 0 48px', borderRadius: '50%', background: '#0b4da2', border: '2px solid #a4fdffff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Icon sx={{ color: '#fff', fontSize: 28 }} />
                    </div>
                    <Typography style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.2rem', fontWeight: 500 }}>{label}</Typography>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div style={{ margin: '0 auto', display: 'flex', justifyContent: 'flex-start', width: '1230px', borderRadius: '16px',
            flexWrap: 'nowrap', gap: '20px', }}>
            <Typography variant="body1" paragraph style={{ color: '#fff', fontFamily: 'Inter, sans-serif', 
              fontSize: '1.125rem', marginTop: '25px', fontWeight: 500, textAlign: 'left', padding: '0 12px 0 12px'}}>
              Very few property tax consultants have even a minimal understanding of oil field operations.  This limits their ability
              to appropriately address these issues in a manner compliant with tax code requirements.<br/><br/> Operators shouldn't 
              pay a tax representative to do oil & gas analysis that they are already paying more qualified engineers to do.<br/><br/>
              Interest owners shouldn't pay a tax representative to conduct oil & gas analysis that they have no experience with.
            </Typography>
          </div>
          <div style={{ width: '100%', maxWidth: '1600px', margin: '24px auto', display: 'flex', justifyContent: 'center' }}>
            <div style={{ height: '1px', background: '#a4fdffff', opacity: 0.9, width: '90%' }} />
          </div>
          <div style={{ margin: '0 auto', display: 'flex', justifyContent: 'flex-start', width: '1230px', boxSizing: 'border-box',
             alignItems: 'center', }}>
            <Typography variant="h1" header style={{ color: '#fff', fontFamily: 'Inter, sans-serif', 
              fontSize: '2.25rem', fontWeight: 500, marginTop: '15px', textAlign: 'left' }}>
              Mineral Taxes in Three Easy Steps
            </Typography>
          </div>
          <div style={{ margin: '0 auto', display: 'flex', justifyContent: 'flex-start', width: '1230px', borderRadius: '16px',
           flexWrap: 'nowrap', gap: '20px', }}>
            <div style={{width: '375px', overflow: 'hidden', }}>
              <Typography variant="h1" header style={{ color: '#fff', fontFamily: 'Inter, sans-serif',
                 fontSize: '1.5rem', fontWeight: 500, textAlign: 'center', marginBottom: '20px' }}>
                Data
              </Typography>
              <div style={{minWidth: '375px', overflow: 'hidden', borderRadius: '16px', boxShadow: '0 4px 16px rgba(0,0,0,0.5)' }}>
                <img src="/msdca_lease_Pricing.png" alt="Section" style={{display: 'block', height: '100%', width: '100%',
                 objectFit: 'cover', borderRadius: '16px', boxShadow: '0 4px 16px rgba(0,0,0,0.5)' }} />
              </div>
            </div>
            <div style={{width: '400px', overflow: 'hidden' }}>
              <Typography variant="h1" header style={{ color: '#fff', fontFamily: 'Inter, sans-serif',
                 fontSize: '1.5rem', fontWeight: 500, textAlign: 'center', marginBottom: '20px' }}>
                  Reservoir Analysis
              </Typography>
              <div style={{minWidth: '375px', overflow: 'hidden', borderRadius: '16px', boxShadow: '0 4px 16px rgba(0,0,0,0.5)' }}>
                <img src="/decline.png" alt="Section" style={{display: 'block', height: '100%', width: '100%',
                 objectFit: 'cover', borderRadius: '16px', marginTop: '25px', boxShadow: '0 4px 16px rgba(0,0,0,0.5)' }} />
              </div>
            </div>
            <div style={{width: '400px', overflow: 'hidden', }}>
              <Typography variant="h1" header style={{ color: '#fff', fontFamily: 'Inter, sans-serif',
                 fontSize: '1.5rem', fontWeight: 500, textAlign: 'center', marginBottom: '20px' }}>
                  Admin Support
              </Typography>
              <div style={{minWidth: '375px', height: '215px', overflow: 'hidden', borderRadius: '16px', boxShadow: '0 4px 16px rgba(0,0,0,0.5)' }}>
                <img src="/Blank_Protest_Form.png" alt="Section" style={{display: 'block', height: '100%', width: '100%',
                 objectFit: 'cover', borderRadius: '16px', boxShadow: '0 4px 16px rgba(0,0,0,0.5)' }} />
              </div>
            </div>
          </div>
          <div style={{ margin: '0 auto', display: 'flex', justifyContent: 'flex-start', width: '1230px', 
           border: '2px solid #a4fdffff', borderRadius: '16px', flexWrap: 'nowrap', }}>
            <div style={{ flex: '1 1', maxWidth: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Typography variant="h1" header
                style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '2.25rem', fontWeight: 500, textAlign: 'center' }}>
                <b>Data</b>
              </Typography>
            </div>              
            <div style={{ flex: '1 1', minWidth: '900px', position: 'relative' }}>
              <div
                style={{ position: 'absolute', left: 0, top: '5%', height: '90%', width: '2px', backgroundColor: '#a4fdffff', }}>
              </div>
              <div style={{ flex: '1 1', minWidth: '1000px', position: 'relative', display: 'flex', flexDirection: 'row' }}>
                <Typography variant="body1" paragraph
                  style={{ flex: '0 0 250px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 0, color: '#fff',
                    fontFamily: 'Inter, sans-serif', fontSize: '1.3rem', fontWeight: 500, textAlign: 'center'}}>
                  <b>Single Data Source</b>
                </Typography>
                <Typography variant="body1" paragraph
                  style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.125rem', marginTop: '25px', fontWeight: 500, textAlign: 'left',
                    padding: '0 12px 0 12px'}}>
                      Replace hours of fragmented oil & gas and tax appraisal research with one centralized source for comprehensive appraisal data.
                </Typography>
              </div>
              <div style={{ width: '100%', maxWidth: '1600px', display: 'flex', justifyContent: 'center' }}>
                <div style={{ height: '1px', background: '#a4fdffff', opacity: 0.9, width: '95%' }} />
              </div>
              <div style={{ flex: '1 1', minWidth: '1000px', position: 'relative', display: 'flex', flexDirection: 'row' }}>
                <Typography variant="body1" paragraph
                  style={{ flex: '0 0 250px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 0, color: '#fff',
                    fontFamily: 'Inter, sans-serif', fontSize: '1.3rem', fontWeight: 500, textAlign: 'center'}}>
                  <b>Affordable Price Point</b>
                </Typography>
                <Typography variant="body1" paragraph
                  style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.125rem', marginTop: '25px', fontWeight: 500, textAlign: 'left',
                    padding: '0 12px 0 12px'}}>
                    Eliminate the cost of bloated data packages that <i>start</i> at tens of thousands of dollars per year. Access only the appraisal
                      data you need at a fraction of the traditional cost.
                </Typography>                             
              </div>
              <div style={{ width: '100%', maxWidth: '1600px', display: 'flex', justifyContent: 'center' }}>
                <div style={{ height: '1px', background: '#a4fdffff', opacity: 0.9, width: '95%' }} />
              </div>
              <div style={{ flex: '1 1', minWidth: '1000px', position: 'relative', display: 'flex', flexDirection: 'row' }}>
                <Typography variant="body1" paragraph
                  style={{ flex: '0 0 250px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 0, color: '#fff',
                    fontFamily: 'Inter, sans-serif', fontSize: '1.3rem', fontWeight: 500, textAlign: 'center'}}>
                  <b>Tax Ready</b>
                </Typography>
                <Typography variant="body1" paragraph
                  style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.125rem', marginTop: '25px', fontWeight: 500, textAlign: 'left',
                    padding: '0 12px 0 12px'}}>
                    The data in our system is preformatted for tax purposes to eliminate the need further massage data after already
                    paying for an expensive contract from a third-party.
                </Typography>
              </div>
            </div>
          </div>
          <div style={{ margin: '0 auto', display: 'flex', justifyContent: 'flex-start', width: '1230px', 
           border: '2px solid #a4fdffff', borderRadius: '16px', flexWrap: 'nowrap', }}>          
            <div style={{ flex: '1 1', maxWidth: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Typography variant="h1" header
                style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '2.25rem', fontWeight: 500, textAlign: 'center' }}>
                <b>Reservoir Analysis</b>
              </Typography>
            </div>              
            <div style={{ flex: '1 1', minWidth: '900px', position: 'relative' }}>
              <div
                style={{ position: 'absolute', left: 0, top: '5%', height: '90%', width: '2px', backgroundColor: '#a4fdffff', }}>
              </div>
              <div style={{ flex: '1 1', minWidth: '1000px', position: 'relative', display: 'flex', flexDirection: 'row' }}>
                <Typography variant="body1" paragraph
                  style={{ flex: '0 0 250px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 0, color: '#fff',
                    fontFamily: 'Inter, sans-serif', fontSize: '1.3rem', fontWeight: 500, textAlign: 'center'}}>
                  <b>Confidence</b>
                </Typography>
                <Typography variant="body1" paragraph
                  style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.125rem', marginTop: '25px', fontWeight: 500, textAlign: 'left',
                    padding: '0 12px 0 12px'}}>
                      Have peace of mind knowing that your tax calculations follow standard oil & gas industry decline and economic
                       methodologies that are complient with tax code requirements.
                </Typography>
              </div>
              <div style={{ width: '100%', maxWidth: '1600px', display: 'flex', justifyContent: 'center' }}>
                <div style={{ height: '1px', background: '#a4fdffff', opacity: 0.9, width: '95%' }} />
              </div>
              <div style={{ flex: '1 1', minWidth: '1000px', position: 'relative', display: 'flex', flexDirection: 'row' }}>
                <Typography variant="body1" paragraph
                  style={{ flex: '0 0 250px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 0, color: '#fff',
                    fontFamily: 'Inter, sans-serif', fontSize: '1.3rem', fontWeight: 500, textAlign: 'center'}}>
                  <b>Clarity</b>
                </Typography>
                <Typography variant="body1" paragraph
                  style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.125rem', marginTop: '25px', fontWeight: 500, textAlign: 'left',
                    padding: '0 12px 0 12px'}}>
                      DCATax walks users through every step of the process to ensure users understand what information is needed,
                       why it matters, and how to move from raw numbers to a defensible market value.
                </Typography>                             
              </div>
              <div style={{ width: '100%', maxWidth: '1600px', display: 'flex', justifyContent: 'center' }}>
                <div style={{ height: '1px', background: '#a4fdffff', opacity: 0.9, width: '95%' }} />
              </div>
              <div style={{ flex: '1 1', minWidth: '1000px', position: 'relative', display: 'flex', flexDirection: 'row' }}>
                <Typography variant="body1" paragraph
                  style={{ flex: '0 0 250px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 0, color: '#fff',
                    fontFamily: 'Inter, sans-serif', fontSize: '1.3rem', fontWeight: 500, textAlign: 'left'}}>
                  <b>Speed</b>
                </Typography>
                <Typography variant="body1" paragraph
                  style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.125rem', marginTop: '25px', fontWeight: 500, textAlign: 'left',
                    padding: '0 12px 0 12px'}}>
                      Conduct decline analysis, Lease Operating Expense analysis, and Division Order maintenance
                      in a quick, easy, and tax-ready format that dramatically frees up time spend elsewhere.
                </Typography>
              </div>
            </div>
          </div>
          <div style={{ margin: '0 auto', display: 'flex', justifyContent: 'flex-start', width: '1230px', 
           border: '2px solid #a4fdffff', borderRadius: '16px', flexWrap: 'nowrap', }}>
            <div style={{ flex: '1 1', maxWidth: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Typography variant="h1" header
                style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '2.25rem', fontWeight: 500, textAlign: 'center' }}>
                <b>Admin Support</b>
              </Typography>
            </div>              
            <div style={{ flex: '1 1', minWidth: '900px', position: 'relative' }}>
              <div
                style={{ position: 'absolute', left: 0, top: '5%', height: '90%', width: '2px', backgroundColor: '#a4fdffff', }}>
              </div>
              <div style={{ flex: '1 1', minWidth: '1000px', position: 'relative', display: 'flex', flexDirection: 'row' }}>
                <Typography variant="body1" paragraph
                  style={{ flex: '0 0 250px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 0, color: '#fff',
                    fontFamily: 'Inter, sans-serif', fontSize: '1.3rem', fontWeight: 500, textAlign: 'center'}}>
                  <b>Documents</b>
                </Typography>
                <Typography variant="body1" paragraph
                  style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.125rem', marginTop: '25px', fontWeight: 500, textAlign: 'left',
                    padding: '0 12px 0 12px'}}>
                      Store, track, and file documents in our tool while staying aware of required filings.
                </Typography>
              </div>
              <div style={{ width: '100%', maxWidth: '1600px', display: 'flex', justifyContent: 'center' }}>
                <div style={{ height: '1px', background: '#a4fdffff', opacity: 0.9, width: '95%' }} />
              </div>
              <div style={{ flex: '1 1', minWidth: '1000px', position: 'relative', display: 'flex', flexDirection: 'row' }}>
                <Typography variant="body1" paragraph
                  style={{ flex: '0 0 250px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 0, color: '#fff',
                    fontFamily: 'Inter, sans-serif', fontSize: '1.3rem', fontWeight: 500, textAlign: 'center'}}>
                  <b>Schedules</b>
                </Typography>
                <Typography variant="body1" paragraph
                  style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.125rem', marginTop: '25px', fontWeight: 500, textAlign: 'left',
                    padding: '0 12px 0 12px'}}>
                      Manage important schedules and deadlines for your tax filings with our built-in calendar and notification system.
                </Typography>                             
              </div>
              <div style={{ width: '100%', maxWidth: '1600px', display: 'flex', justifyContent: 'center' }}>
                <div style={{ height: '1px', background: '#a4fdffff', opacity: 0.9, width: '95%' }} />
              </div>
              <div style={{ flex: '1 1', minWidth: '1000px', position: 'relative', display: 'flex', flexDirection: 'row' }}>
                <Typography variant="body1" paragraph
                  style={{ flex: '0 0 250px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 0, color: '#fff',
                    fontFamily: 'Inter, sans-serif', fontSize: '1.3rem', fontWeight: 500, textAlign: 'left'}}>
                  <b>Direct Contact</b>
                </Typography>
                <Typography variant="body1" paragraph
                  style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.125rem', marginTop: '25px', fontWeight: 500, textAlign: 'left',
                    padding: '0 12px 0 12px'}}>
                      DCATax eliminates the struggle of trying to find the right person to talk to and provides the direct contact information
                       for your specific tax needs.
                </Typography>
              </div>
            </div>            
          </div>
          <div style={{ width: '100%', maxWidth: '1600px', margin: '40px auto 24px', display: 'flex', justifyContent: 'center' }}>
            <div style={{ height: '1px', background: '#a4fdffff', opacity: 0.9, width: '90%' }} />
          </div>
          <div style={{ margin: '0 auto', display: 'flex', justifyContent: 'flex-start', width: '1230px', boxSizing: 'border-box',
             alignItems: 'center', }}>
            <Typography variant="h1" header style={{ color: '#fff', fontFamily: 'Inter, sans-serif', 
              fontSize: '2.25rem', fontWeight: 500, marginTop: '15px', textAlign: 'left' }}>
              An Appraisal Solution for Everyone
            </Typography>
          </div>
          <div style={{ margin: '0 auto 50px', display: 'flex', alignItems: 'stretch', width: '1230px', gap: '24px' }}>
            <div style={{ flex: '1 1 0', minWidth: 0, display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
              border: '2px solid #a4fdffff', borderRadius: '16px', boxSizing: 'border-box', overflow: 'hidden' }}>
              {[
                {
                  title: 'Interest Owners', items: ['Eliminate guesswork about how values are calculated', 
                    'Guidance on tax calendar and procedures', 'Documents and data repository'],
                },
                {
                  title: 'Operators', items: ['Tax-Ready Decline analysis', 'Utilize existing company data',
                     'Eliminate spending on redundant work from tax agents'],
                },
                {
                  title: 'Appraisers', items: ['Setup thousands of leases in seconds', "Mass process LOE's with a click",
                     'No bloated data packages'],
                },
                {
                  title: "CAD's", items: ['Instant tracking of mineral data', 'County & jurisdiction analytics',
                     'Streamlined data delivery'],
                },
              ].map((section, index) => (
                  <div key={section.title} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '28px 32px',
                    boxSizing: 'border-box', borderRight: index % 2 === 0 ? '2px solid #a4fdffff' : 'none',
                    borderBottom: index < 2 ? '2px solid #a4fdffff' : 'none' }}>
                    <Typography variant="h2" style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '1.5rem',
                      fontWeight: 500, textAlign: 'center', marginBottom: '14px' }}>
                      <b>{section.title}</b>
                    </Typography>
                    <div aria-hidden="true" style={{ width: '250px', height: '2px', flex: '0 0 2px',
                      marginBottom: '18px', backgroundColor: '#a4fdffff' }} />
                    <ul style={{ width: '100%', margin: 0, paddingLeft: '24px', color: '#fff', fontFamily: 'Inter, sans-serif',
                      fontSize: '1.125rem', fontWeight: 500, lineHeight: 1.8, textAlign: 'left' }}>
                      {section.items.map(item => <li key={item}>{item}</li>)}
                    </ul>
                  </div>
              ))}
            </div>
            <div style={{ flex: '0 0 450px', minWidth: '450px', overflow: 'hidden', borderRadius: '16px',
              boxShadow: '0 4px 16px rgba(0,0,0,0.5)' }}>
              <img src="/Users_image.png" alt="People who benefit from DCATax" style={{ display: 'block', height: '100%', width: '100%',
                objectFit: 'cover', borderRadius: '16px' }} />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
